module.exports = __webpack_public_path__ + "static/media/006.737f5491.jpg";